import { Typography } from '@mui/material';
import { GridColDef, GridComparatorFn } from '@mui/x-data-grid';
import { DataGridPro, GridPinnedRowsProp } from '@mui/x-data-grid-pro';
import { GridToolbar } from '@mui/x-data-grid-premium';
import { ReactElement } from 'react';
import { Node } from './models';
import { COLOR_DARK } from './theme';

export declare type AlignType = 'left' | 'center' | 'right';

export function KinaseGrid({ filteredData, selected }: {
  filteredData: Array<any>,
  selected: Array<Node>
}): ReactElement {

  if (filteredData.length === 0) return <></>

  const customComparator: GridComparatorFn<string> = (v1: string, v2: string): number => {
    return v1 < v2 ? -1 : 1;
  }

  const allKeys = new Set(filteredData.map(v => Object.keys(v)).flat(2))
  const allKinases = Array.from(allKeys).filter(key => key !== 'cytokine')
  const kinaseColumns = allKinases.map((v: string) => ({
    field: v,
    headerName: v,
    flex: 1,
    minWidth: 75,
    align: 'left' as AlignType
  }))

  const columns: GridColDef[] = [
    {
      field: 'cytokine',
      headerName: 'Cytokine',
      flex: 1,
      minWidth: 175,
      align: 'left',
      sortComparator: customComparator
    },
    ...kinaseColumns
  ];

  const pinnedNames = selected.map(v => v.name)//.concat(['Effect Cytokines of Interest', 'Effect Total Cytokines'])
  const pinnedRows: GridPinnedRowsProp = {
    top: filteredData.filter(v => pinnedNames.includes(v.cytokine)),
  };

  let height = ''
  if (pinnedRows.top && pinnedRows.top.length >= 4) {
    height = `${(pinnedRows.top.length - 4) * 50 + 500}px`;
  }
  else {
    height = '500px';
  }

  return (
    <>
      <Typography variant='h2' sx={{ mt: 6, mb: 3 }}>Kinases Associated With Search</Typography>
      <DataGridPro
        sx={{ height: height, mb: 6 }}
        rows={filteredData}
        pinnedRows={pinnedRows}
        density='compact'
        disableSelectionOnClick={true}
        getRowId={(row) => `${row.cytokine}`}
        columns={columns}
        pinnedColumns={{ left: ["cytokine"] }}
        components={{ Toolbar: GridToolbar }}
        componentsProps={{
          toolbar: {
            sx: {
              '& .MuiButtonBase-root': {
                color: COLOR_DARK,
              }
            },
          },
        }}
        pageSize={5}
        rowThreshold={0}
        initialState={{
          sorting: { sortModel: [{ field: 'cytokine', sort: 'asc' }] }
        }}
        experimentalFeatures={{ rowPinning: true }}
      />
    </>
  );
}
